import {
  DEFAULT_VOLUME as SHARED_DEFAULT_VOLUME,
  DEFAULT_PLAYBACK_RATE as SHARED_DEFAULT_PLAYBACK_RATE,
} from '../shared/constants';
export const USER_PREFERENCES_URL = process.env.USER_PREFERENCES_URL;

export const DEFAULT_PLAYBACK_RATE = SHARED_DEFAULT_PLAYBACK_RATE;
export const DEFAULT_VOLUME_PERCENT = SHARED_DEFAULT_VOLUME;
export const DEFAULT_SUBTITLE_LANGUAGE = '';
export const DEFAULT_MARKER_PREVIEW_ENABLED = false;
export const DEFAULT_AUTOPLAY_ENABLED = false;
export const DEFAULT_SUBTITLE_ENABLED = true;

export const UPDATE_PREFERENCES_DEBOUNCE_TIME = 500;
